import React from 'react';

const SingleDayCompo = () => {
    return (
        <div className='mx-auto lg:mb-20 md:mb-16 sm:mb-10 mb-10'>
            <h1 className='text-md my-5'>If you're in town for a day or two or you want to check out the
                environment before making a commitment, it's a good idea to
                get yourself a day pass.</h1>
        </div>
    );
};

export default SingleDayCompo;